import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-description-modal',
  templateUrl: './dashboard-description-modal.component.html',
  styleUrls: ['./dashboard-description-modal.component.css']
})
export class DashboardDescriptionModalComponent implements OnInit {
  ispopUpShow: boolean = false;
  @Output() modelOpen = new EventEmitter<boolean>();
  @Input() desc;
  constructor() { }

  ngOnInit(): void {
    console.log('this.progDesc',this.desc)
  }

  closePop() {
    this.modelOpen.emit(false);
  }

}
